import { render, staticRenderFns } from "./demandSort.vue?vue&type=template&id=b218c60c&scoped=true&"
import script from "./demandSort.vue?vue&type=script&lang=js&"
export * from "./demandSort.vue?vue&type=script&lang=js&"
import style0 from "./demandSort.vue?vue&type=style&index=0&id=b218c60c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b218c60c",
  null
  
)

export default component.exports